export default function bulkSelect() {
  return {
    selectedIds: [],
    allIds: [],
    confirmOpen: false,
    deleting: false,

    init() {
      this.allIds = JSON.parse(this.$el.dataset.allIds || "[]");
    },

    get allSelected() {
      return (
        this.allIds.length > 0 &&
        this.allIds.every((id) => this.selectedIds.includes(id))
      );
    },

    get someSelected() {
      return this.selectedIds.length > 0 && !this.allSelected;
    },

    toggleAll() {
      if (this.allSelected) {
        this.selectedIds = [];
      } else {
        this.selectedIds = [...this.allIds];
      }
    },

    toggle(id) {
      const i = this.selectedIds.indexOf(id);
      if (i === -1) this.selectedIds.push(id);
      else this.selectedIds.splice(i, 1);
    },

    isSelected(id) {
      return this.selectedIds.includes(id);
    },

    async bulkDelete(endpoint) {
      this.deleting = true;
      try {
        const res = await fetch(endpoint, {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ ids: this.selectedIds }),
        });
        if (res.ok) {
          window.location.reload();
        }
      } finally {
        this.deleting = false;
        this.confirmOpen = false;
      }
    },
  };
}
